import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  RESET_ERROR,
  RESET_SUCCESS,
  VIEW_USER_ERROR,
  VIEW_USER_SUCCESS,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
} from "../actionTypes/authActionTypes";
import apiCall from "../../helpers/apiCall";
import errorProcessor from "../../helpers/errorProcessor";
import { notification } from "antd";

const token = localStorage.getItem("x-auth-token");

export const loginAction = (loginData) => async (dispatch) => {
  try {
    const loginResponse = await apiCall.post(`/auth/login`, loginData);
    localStorage.setItem("x-auth-token", loginResponse.data.data.token);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: loginResponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: LOGIN_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const resetPassword = (id) => async (dispatch) => {
  try {
    const resetPasswordResponse = await apiCall.post(`/auth/admin/user/${id}`,{}, {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": token,
      },
    });
    dispatch({
      type: LOGIN_SUCCESS,
      payload: resetPasswordResponse.data,
    });
    notification.success({ message: "Password reseted successfully! Default Password: Shecancode@2020" });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: LOGIN_ERROR,
      payload: error.response.data || err,
    });
    notification.error({ message: "failed to reset password" });
  }
};

export const viewUsersAction = (loginData) => async (dispatch) => {
  try {
    const allUsersResponse = await apiCall.get(`/auth/admin/users`, {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": token,
      },
    });
    dispatch({
      type: VIEW_USER_SUCCESS,
      payload: allUsersResponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: VIEW_USER_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const addUserAction = (newUserData) => async (dispatch) => {
  try {
    const addUserResponse = await apiCall.post(
      `/auth/admin/invite`,
      newUserData,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
      }
    );
    dispatch({
      type: ADD_USER_SUCCESS,
      payload: addUserResponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: ADD_USER_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const updateProfileAction = (userData) => async (dispatch) => {
  try {
    const updateProfileResponse = await apiCall.patch(
      `/auth/user/profile`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
      }
    );
    dispatch({
      type: UPDATE_PROFILE_SUCCESS,
      payload: updateProfileResponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: UPDATE_PROFILE_ERROR,
      payload: error.response.data || err,
    });
  }
};
